import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEnvelopeIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M14.536 21.686C14.574 21.7807 14.64 21.8615 14.7253 21.9175C14.8105 21.9736 14.9108 22.0022 15.0128 21.9996C15.1148 21.997 15.2136 21.9633 15.2958 21.9029C15.3781 21.8426 15.4399 21.7585 15.473 21.662L21.973 2.662C22.005 2.57339 22.0111 2.4775 21.9906 2.38555C21.9701 2.2936 21.9238 2.20939 21.8572 2.14277C21.7906 2.07616 21.7064 2.02989 21.6144 2.00939C21.5225 1.98888 21.4266 1.99499 21.338 2.027L2.33799 8.527C2.24148 8.56009 2.15741 8.62191 2.09706 8.70417C2.03671 8.78642 2.00296 8.88517 2.00035 8.98715C1.99773 9.08914 2.02638 9.18949 2.08245 9.27472C2.13851 9.35996 2.21931 9.426 2.31399 9.46399L10.244 12.644C10.4947 12.7444 10.7224 12.8945 10.9136 13.0852C11.1047 13.276 11.2552 13.5035 11.356 13.754L14.536 21.686Z",
		stroke: "white",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M21.854 2.14697L10.914 13.086",
		stroke: "white",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgEnvelopeIcon;
